(() => {
  const installed = new WeakSet();
  const pendingCount = new WeakSet();
  document.addEventListener('click', event => {
    if (!matchMedia('(max-width:760px)').matches) return;
    const path = event.composedPath();
    const button = path.find(node => node?.tagName === 'BUTTON');
    if (!button || !button.closest('.e2-start-choices,#counts,.e2-counts')) return;
    const host = path.find(node => node?.tagName === 'COZYSTORY-DESIGN-RUNTIME');
    if (!host) return;
    pendingCount.add(host);
    host.cozyAlignCount?.();
  }, true);
  function mount(host) {
    const root = host.shadowRoot;
    const product = host.closest('.product');
    const media = product?.querySelector(':scope > .product__media-wrapper');
    const oldPortal = media?.querySelector('[data-cozystory-preview],[data-cozytree-preview]');
    if (!root || !oldPortal || !host.unmountProduct) return;
    const sheets = [...oldPortal.shadowRoot.querySelectorAll('link,style')].map(node => node.cloneNode(true));
    host.unmountColumns?.();
    host.unmountColumns = null;
    host.unmountProduct();
    const preview = root.querySelector('.ct-preview');
    const viewport = root.querySelector('.ct-viewport');
    if (!preview || !viewport) return;
    installed.add(host);
    host.dataset.productHost = 'true';
    const editorStyle = document.createElement('style');
    editorStyle.textContent = '.ct-editor{display:block!important;grid-template-columns:minmax(0,1fr)!important}.ct-controls{width:100%!important;max-width:none!important}';
    root.append(editorStyle);
    const anchor = document.createComment('preview return');
    preview.before(anchor);
    const originals = [...media.children].map(node => [node, node.getAttribute('style')]);
    const mediaStyle = media.getAttribute('style');
    const galleryImage = media.querySelector('.product__media');
    const rect = galleryImage?.getBoundingClientRect();
    const ratio = rect?.width && rect?.height ? rect.width / rect.height : 1;
    const slot = document.createElement('div');
    slot.className = 'cozy-gallery-preview-slot';
    slot.style.aspectRatio = String(ratio);
    const portal = document.createElement('div');
    portal.dataset.cozystoryPreview = '';
    const shadow = portal.attachShadow({mode:'open'});
    shadow.append(...sheets);
    const page = document.createElement('div');
    page.className = 'ct-page';
    shadow.append(page);
    page.append(preview);
    const style = document.createElement('style');
    style.textContent = `:host{display:block!important;width:100%;height:100%;position:relative!important;top:0!important}.ct-page{padding:0!important;margin:0!important;width:100%!important;height:100%!important;max-width:none!important;background:transparent!important}.ct-page .ct-preview{position:relative!important;top:0!important;width:100%!important;height:100%!important;max-width:none!important;max-height:none!important;min-height:0!important;margin:0!important;padding:0!important;border:0!important;border-radius:20px!important;box-sizing:border-box}.ct-page .ct-preview__crop{width:100%!important;height:100%!important;max-width:none!important;max-height:none!important;aspect-ratio:auto!important;border-radius:20px!important;overflow:hidden}.ct-page .ct-preview__stage{width:100%!important;height:100%!important;max-height:none!important;aspect-ratio:auto!important}:host([data-compact]){position:fixed!important;top:0!important;left:0!important;width:100vw!important;height:calc(clamp(160px,29svh,260px) * 1.3225)!important;z-index:30;background:#FCFBF9}:host([data-compact]) .ct-page{width:100%!important;height:calc(clamp(160px,29svh,260px) * 1.3225)!important;margin:0!important}:host([data-compact]) .ct-preview,:host([data-compact]) .ct-preview__crop{border-radius:0!important}`;
    shadow.append(style);
    slot.append(portal);
    media.append(slot);
    const outerStyle = document.createElement('style');
    outerStyle.textContent = `.cozy-gallery-preview-slot{position:sticky;top:24px;width:100%;z-index:4}.cozy-gallery-preview-slot>[data-cozystory-preview]{height:100%;width:100%}@media(max-width:760px){.cozy-gallery-preview-slot{position:relative;top:0;margin-bottom:20px}.cozy-gallery-preview-slot>[data-compact]{position:fixed!important;top:0!important;left:0!important;width:100vw!important;height:calc(clamp(160px,29svh,260px) * 1.3225)!important;background:#FCFBF9;box-shadow:0 3px 12px #00000012;z-index:30}}`;
    document.head.append(outerStyle);
    const mq = matchMedia('(max-width:760px)');
    let frame = 0;
    let zoomMode = null;
    let transitionAnimation;
    let hasLayout = false;
    const stage = preview.querySelector('.ct-preview__stage');
    const readZoom = () => {
      const match = stage?.style.transform.match(/scale\(([^)]+)\)/);
      return match ? Number(match[1]) : 1;
    };
    const zoomStates = {gallery: 1, sticky: readZoom()};
    const setZoom = value => {
      const buttons = [...preview.querySelectorAll('.ct-preview__zoom-button,.e2-zoom button')];
      for (let i = 0; i < 12 && Math.abs(readZoom() - value) > .01; i++) {
        const before = readZoom();
        const button = buttons.find(node => node.textContent.trim() === (before > value ? '−' : '+'));
        if (!button || button.disabled) break;
        button.click();
        if (readZoom() === before) break;
      }
    };
    let alignTimer;
    host.cozyAlignCount = () => {
      clearTimeout(alignTimer);
      alignTimer = setTimeout(() => {
        if (!mq.matches || !pendingCount.has(host) || viewport.dataset.active !== 'true') return;
        const question = root.querySelector('.ct-count:not([hidden]),.e2-counts:not([hidden])') || root.querySelector('.ct-controls');
        if (!question) return;
        const stickyHeight = Math.min(260, Math.max(160, innerHeight * .29)) * 1.3225;
        const top = scrollY + question.getBoundingClientRect().top - stickyHeight - 12;
        pendingCount.delete(host);
        window.scrollTo({top: Math.max(0, top), behavior: 'instant'});
        schedule();
      }, 250);
    };
    // The preview lives in a separate shadow root now, so editor navigation
    // must account for its mobile overlay after the next panel becomes visible.
    let nextPanelFrom = null, nextPanelFrame = 0, nextPanelTimer = 0;
    const clearNextPanel = () => {
      nextPanelFrom = null;
      clearTimeout(nextPanelTimer);
      cancelAnimationFrame(nextPanelFrame);
      nextPanelFrame = 0;
    };
    const alignNextPanel = () => {
      nextPanelFrame = 0;
      if (!nextPanelFrom) return;
      const panel = root.querySelector('.ct-character:not([hidden]),.e2-person:not([hidden])');
      if (!panel || panel === nextPanelFrom) return;
      const target = panel.querySelector('[data-group="type"],[data-category="characterType"]');
      if (!target) return;
      clearNextPanel();
      const offset = mq.matches ? Math.min(260, Math.max(160, innerHeight * .29)) * 1.3225 + 12 : 24;
      window.scrollTo({top: Math.max(0, scrollY + target.getBoundingClientRect().top - offset), behavior: 'instant'});
      schedule();
    };
    const queueNextPanel = () => {
      if (nextPanelFrom && !nextPanelFrame) nextPanelFrame = requestAnimationFrame(alignNextPanel);
    };
    const onNextPerson = event => {
      const button = event.target.closest?.('.ct-next-person,.e2-next');
      if (!button) return;
      clearNextPanel();
      nextPanelFrom = button.closest('.ct-character,.e2-person');
      // A validation failure leaves the current panel active and must not scroll.
      nextPanelTimer = setTimeout(clearNextPanel, 15000);
      queueNextPanel();
    };
    root.addEventListener('click', onNextPerson, true);
    const panelObserver = new MutationObserver(queueNextPanel);
    panelObserver.observe(root, {subtree:true, childList:true, attributes:true, attributeFilter:['hidden']});
    const restoreGallery = () => originals.forEach(([node,value]) => value === null ? node.removeAttribute('style') : node.setAttribute('style',value));
    function update() {
      frame = 0;
      const active = viewport.dataset.active === 'true';
      slot.hidden = !active;
      media.style.removeProperty('display');
      media.style.setProperty('align-self','stretch');
      if (active) originals.forEach(([node]) => node.style.setProperty('display','none','important'));
      else restoreGallery();
      const bounds = slot.getBoundingClientRect();
      const compact = active && mq.matches && bounds.bottom <= 0 && product.getBoundingClientRect().bottom > Math.min(260, Math.max(160, innerHeight * .29)) * 1.3225;
      const wasCompact = portal.hasAttribute('data-compact');
      portal.toggleAttribute('data-compact',compact);
      if (hasLayout && wasCompact !== compact && mq.matches && !matchMedia('(prefers-reduced-motion: reduce)').matches) {
        transitionAnimation?.cancel();
        transitionAnimation = portal.animate([
          {opacity: .45, transform: `translateY(${compact ? '-10px' : '8px'})`},
          {opacity: 1, transform: 'translateY(0)'}
        ], {duration: 280, easing: 'cubic-bezier(.22,1,.36,1)'});
      }
      hasLayout = true;
      if (mq.matches) {
        const nextMode = compact ? 'sticky' : 'gallery';
        if (nextMode !== zoomMode) {
          if (zoomMode) zoomStates[zoomMode] = readZoom();
          zoomMode = nextMode;
          setZoom(zoomStates[nextMode]);
        }
      } else zoomMode = null;
      host.dataset.productDesktop = mq.matches ? 'false' : 'true';
    }
    const schedule = () => { if (!frame) frame = requestAnimationFrame(update); };
    const observer = new MutationObserver(schedule);
    observer.observe(viewport,{attributes:true,attributeFilter:['data-active']});
    window.addEventListener('scroll',schedule,{passive:true});
    window.addEventListener('resize',schedule,{passive:true});
    mq.addEventListener('change',schedule);
    host.previewRoot = shadow;
    host.unmountProduct = () => {
      clearNextPanel();panelObserver.disconnect();root.removeEventListener('click',onNextPerson,true);
      observer.disconnect();transitionAnimation?.cancel();cancelAnimationFrame(frame);clearTimeout(alignTimer);delete host.cozyAlignCount;
      window.removeEventListener('scroll',schedule);window.removeEventListener('resize',schedule);mq.removeEventListener('change',schedule);
      anchor.after(preview);anchor.remove();slot.remove();outerStyle.remove();editorStyle.remove();restoreGallery();
      mediaStyle === null ? media.removeAttribute('style') : media.setAttribute('style',mediaStyle);
      installed.delete(host);delete host.dataset.productHost;delete host.dataset.productDesktop;
    };
    update();
    if (pendingCount.has(host)) host.cozyAlignCount();
  }
  setInterval(() => document.querySelectorAll('cozystory-design-runtime[data-ready="true"]').forEach(host => {
    if (!installed.has(host)) mount(host);
  }),300);
})();
